import {format, isValid} from 'date-fns';

/**
 * Форматирует дату в строку локального формата (DD.MM.YYYY), используя date-fns.
 *
 * @param date - Объект Date или строка/число, которое может быть преобразовано в Date.
 * @returns Отформатированную строку даты или пустую строку, если дата некорректна.
 */
export const formatDateToLocalDate = (date: Date | string | number | null | undefined): string => {
  if (!date) {
    return '';
  }

  try {
    const dateObj = new Date(date);

    // Проверяем, является ли дата валидной с помощью date-fns
    if (!isValid(dateObj)) {
      return '';
    }

    return format(dateObj, 'dd.MM.yyyy');
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

/**
 * Форматирует дату и время в строку локального формата (DD.MM.YYYY HH:mm), используя date-fns.
 *
 * @param date - Объект Date или строка/число, которое может быть преобразовано в Date.
 * @returns Отформатированную строку даты и времени или пустую строку, если дата некорректна.
 */
export const formatDateTimeToLocal = (date: Date | string | number | null | undefined): string => {
  if (!date) {
    return '';
  }

  try {
    const dateObj = new Date(date);

    // Проверяем, является ли дата валидной с помощью date-fns
    if (!isValid(dateObj)) {
      return '';
    }

    return format(dateObj, 'dd.MM.yyyy HH:mm');
  } catch (error) {
    console.error('Error formatting date time:', error);
    return '';
  }
};
